import { Component } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-rp-cta-section',
  templateUrl: './cta-section.component.html',
  styleUrls: ['./cta-section.component.scss'],
})
export class CtaSectionComponent {
  getSignupUrl(): string {
    const subdomain = environment.server === 'dev' ? 'dev' : 'app';
    return `https://${subdomain}.uptal.com/register?type=recruiter-program`;
  }
}
